import './specialism.component.js';
import './our-team.component.js';
import './roles.component.js';
import './reviews.component.js';
import './blogs.component.js';
import './gallery.component.js';
import './commitment.component.js';
import './related-vacancies.component.js';